module.exports = __webpack_public_path__ + "static/media/stack-right.5745e860.jpg";